module.exports = __webpack_public_path__ + "media/components/assets/img/logo-0cc7e90d6fddf7e4bded2f2ff7ca17e0.svg";